import {useClientAccountOverview} from "@twigsby/client-data";
import {ColourSolid, ContentBlock, ContentLoader, useLayout} from "@twigsby/frontend-framework";
import {ProgressBar} from "@twigsby/frontend-framework/lib/Components/ProgressBars";
import {FormatLocaleDate, FormatLocaleRelativeStrict} from "@twigsby/helpers";
import React from "react";
import {useTranslation} from "@twigsby/frontend-framework";
import {NavLink} from "react-router-dom";
import {useSite} from "../../Providers/SiteInterfaceProvider";
import {EndpointError} from "../EndpointError";

type UserAccountAllowanceEntryType = {
    title: any;
    figure: any;
    footer: any;
}

const UserAccountAllowanceSmallEntry = (props: UserAccountAllowanceEntryType) => {
    return (
        <div className="user-account-allowance-stat-container small-allowance">
            <div className="user-account-allowance-stat-title">{props.title}</div>
            <div className="user-account-allowance-stat-figure">
                {props.figure}
            </div>
            <div className="user-account-allowance-stat-footer">{props.footer}</div>
        </div>
    )
}

const UserAccountAllowanceEntry = (props: UserAccountAllowanceEntryType) => {
    return (
        <div className="user-account-allowance-stat-container">
            <div className="user-account-allowance-stat-title">{props.title}</div>
            <div className="user-account-allowance-stat-figure">
                {props.figure}
            </div>
            <div className="user-account-allowance-stat-footer">{props.footer}</div>
        </div>
    )
}

const UserAccountAllowance = () => {
    const { isMedium } = useLayout();
    const { currentLocale } = useSite();
    const { t } = useTranslation();

    const { data: userData, status: userStatus, error: userError } = useClientAccountOverview();

    return (
        <>
            {userStatus === "error" ? (
                <EndpointError {...userError} />
            ) : (
                <div className={'user-account-allowance'}>
                    <UserAccountAllowanceEntry
                        title={t('accountAllowance.labels.mailAllowance')}
                        figure={userStatus === 'loading' ? <ContentLoader childCount={1} rounded={true} childWidth={isMedium ? '10em' : '5em'} childHeight={'2em'}/> : <span>{`${(userData?.letterAllowance.remaining + userData?.parcelAllowance.remaining).toLocaleString()}/${(userData?.letterAllowance.total + userData?.parcelAllowance.total).toLocaleString()}`}</span>}
                        footer={userStatus === 'loading' ? ' ' : `${t('accountAllowance.labels.resets')}: ${FormatLocaleDate(userData.allowanceResetDate, currentLocale)}`}
                    />

                    <UserAccountAllowanceEntry
                        title={t('accountAllowance.labels.scanAllowance')}
                        figure={userStatus === 'loading' ? <ContentLoader childCount={1} rounded={true} childWidth={isMedium ? '10em' : '5em'} childHeight={'2em'}/> : <span>{`${(userData.scanAllowance.remaining).toLocaleString()}/${(userData.scanAllowance.total).toLocaleString()}`}</span>}
                        footer={userStatus === 'loading' ? ' ' : `${t('accountAllowance.labels.resets')}: ${FormatLocaleDate(userData.allowanceResetDate, currentLocale)}`}
                    />

                    <UserAccountAllowanceEntry
                        title={t('accountAllowance.labels.renewal')}
                        figure={userStatus === 'loading' ? <ContentLoader childCount={1} rounded={true} childWidth={isMedium ? '10em' : '5em'} childHeight={'2em'} /> : <span>{FormatLocaleDate(userData.mailPlanRenewalDate, currentLocale)}</span>}
                        footer={userStatus === 'loading' ? ' ' : <NavLink to={'/manage-account/payment/renew'}>{t('accountAllowance.actions.renew')}</NavLink>}
                    />

                    <UserAccountAllowanceEntry
                        title={<><abbr title={t('accountAllowance.labels.primeStreetAddress')}>{t('accountAllowance.labels.primeStreetAddressInitials')}</abbr> {t('accountAllowance.labels.renewal')}</>}
                        figure={userStatus === 'loading' ? <ContentLoader childCount={1} rounded={true} childWidth={isMedium ? '10em' : '5em'} childHeight={'2em'} /> : <span>{FormatLocaleRelativeStrict(userData.addressPlanRenewalDate, currentLocale)}</span>}
                        footer={userStatus === 'loading' ? ' ' : <NavLink to={'/manage-account/payment/renew'}>{t('accountAllowance.actions.renew')}</NavLink>}
                    />
                </div>
            )}
        </>
    )
}

export { UserAccountAllowance, UserAccountAllowanceSmallEntry, UserAccountAllowanceEntry }
